import { BnAlertNoticeComponent } from '../../bn-notice/bn-alert-notice/bn-alert-notice.component';
import { BnImpNoticeComponent } from '../../bn-notice/bn-imp-notice/bn-imp-notice.component';
import { BnInfoNoticeComponent } from '../../bn-notice/bn-info-notice/bn-info-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { FlagDataService } from '@services/data-services/flag-data.service';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';
import { FlagResponse } from '@models/flag-response';
import { BillingNewService } from '@services/common/billing-new.service';
import { UserDataService } from '@services/data-services/user-data.service';
import { PolicyDetailsService } from '@services/my-insurance/policy-details.service';
import { tap, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ErrorRedirectionService } from '@services/error-service/error-redirection.service';

declare let OneInc: any;
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BnInfoNoticeComponent, BnImpNoticeComponent, BnAlertNoticeComponent],
  selector: 'app-bn-make-a-payment-landing',
  templateUrl: './bn-make-a-payment-landing.component.html',
  styleUrls: ['./bn-make-a-payment-landing.component.scss'],
})
export class BnMakeAPaymentLandingComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() policy: any;
  @Output() checkingOrSavings: EventEmitter<boolean> = new EventEmitter();
  isOneIncPayment: boolean;
  isNativeApp: boolean;
  isAcmic: boolean;
  isACH: boolean;
  isCCDC: boolean;
  autoPayDate: string;
  isAutoPay: boolean;
  autoPayForce: boolean;
  autoPayAlert: boolean;
  paymentMessage: boolean;
  deductionDay: string;
  paymentInfo: string;
  container: any;
  portalOne: any;
  referenceData3: string;
  userData: any;
  loader: boolean;
  paymentPayload: any;
  minAmountDue: number;
  outstandingBalance: number;
   // TEMP: suppress "Automatic payment scheduled" attention banner until upcoming-bill autopay coverage can be confirmed; flip to false to restore
  suppressAutoPayAlertNotice = true;

  constructor(
    private paymentService: PaymentServiceService,
    private acmicServie: AcmicService,
    private flagDataService: FlagDataService,
    private router: Router,
    private billingNewService: BillingNewService,
    private userDataService: UserDataService,
    private policyDetailsService: PolicyDetailsService,
    private errorRedirectionService: ErrorRedirectionService
  ) {
    this.isAcmic = this.acmicServie.isACMIC();
    this.userDataService.$userData.subscribe((res) => {
      this.userData = res;
    });
    this.loader = false;
  }

  calculateAmounts() {
    if (this.policy.billingDetails[0] && this.policy.hasPriorYearBalance) {
      this.outstandingBalance =
        this.policy.billingDetails[0].outstandingbalance +
        this.policy.priorYearBalance.theAmount;
      this.minAmountDue =
        this.policy.billingDetails[0].amountStillDue +
        this.policy.priorYearBalance.theAmount;
    } else {
      this.outstandingBalance = this.policy.billingDetails[0]?.outstandingbalance;
      this.minAmountDue = this.policy.billingDetails[0]?.amountStillDue;
    }
  }

  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }
  preloadPaymentUsToken(policyNumber: string) {
    if (policyNumber.length === 10) {
      this.paymentService.preloadAndSaveToken(policyNumber);
    }
  }

  onPayByCardBilling() {
    this.loader = true;
    this.calculateAmounts();
    this.proceedWithPayment(); 
  }

  private proceedWithPayment() {
    this.paymentPayload = {
      operation: 'makePayment',
      minAmountDue: this.minAmountDue || this.policy.billingDetails[0]?.minAmountDue,
      accountBalance: this.outstandingBalance || this.policy.billingDetails[0]?.outstandingbalance,
      referenceNumber: this.policy.policynumber.policyNumber,
      clientReferenceData1: this.policy.policynumber.policyNumber,
      clientReferenceData3: this.referenceData3,
      clientReferenceData5: this.policy.residentialAddress?.stateCode,
    };

    this.billingNewService
      .getOneIncTokens(this.paymentPayload)
      .pipe(
        tap((res) => {
          if (!res?.PortalOneSessionKey || !res?.Token) {
            throw new Error('Missing session or token in response');
          }
        }),
        catchError((err) => {
          this.loader = false;
          this.errorRedirectionService.errorRedirectHandler(err);
          return EMPTY;
        })
      )
      .subscribe((res) => {
        this.loader = false;
        this.portalOne.run({
          sessionId: res.PortalOneSessionKey,
          accessTokenId: res.Token,
          displayMode: 'Inline',
          allowClosing: true,
          loadingIndication: false,
        });
      });
  }

  onCheckingOrSavingsAccount() {
    this.checkingOrSavings.emit(true);
    this.billingNewService.setCheckingOrSavingsSelected(true);
  }
  navigateToMyAccount() {
    this.router.navigate(['/profile']);
  }
  getAutoPayDate() {
    this.autoPayDate =
      this.policy.billingDetails[0] &&
        this.policy.billingDetails[0].paymentDueDate
        ? this.policy.billingDetails[0].paymentDueDate
        : '';
    this.calculateAutoPayDate();
  }

  calculateAutoPayDate() {
    if (this.policy.autoPayDetails && this.policy.autoPayDetails.dateMS) {
      const date =
        this.policy.autoPayDetails.dateMS / 86400000 - Date.now() / 86400000;
      this.autoPayForce = date >= 0 && date <= 2.99;
      this.autoPayAlert = date >= 3 && date <= 15;
      this.paymentMessage = this.autoPayForce || this.autoPayAlert;
      this.deductionDay = this.policy.autoPayDetails.deductionDay;
    }
  }

  ngOnInit(): void {
    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      this.isACH = response.ach;
      this.isCCDC = response.isCCDC;
    });
    this.isNative();
    this.referenceData3 = this.isNativeApp ? 'B2C Mobile' : 'B2C';
    this.preloadPaymentUsToken(this.policy?.policynumber?.policyNumber);
    this.getAutoPayDate();
    this.billingNewService.getOneIncPaymentStatus().subscribe((val) => {
      this.isOneIncPayment = val;
    });
    this.container = document.getElementById('portalOneContainer');
    // this.observeContainer(this.container);
    this.portalOne = new OneInc.PortalOne(
      this.container,
      this.subscribeToEvents(this.container)
    );
  }

  subscribeToEvents(container: HTMLElement) {
    if (!container) {
      return;
    }
    container.addEventListener('portalOne.load', () => {
      this.billingNewService.setOneIncPaymentStatus(true);
    });
    container.addEventListener('portalOne.paymentComplete', (data: any) => {
      const paymentCompletePayload = JSON.stringify({
        paymentStatus:        'Success',
        paymentAmount:        data.detail?.paymentAmount,
        transactionId:        data.detail?.transactionId,
        clientReferenceData1: data.detail?.clientReferenceData1 ?? this.paymentPayload?.clientReferenceData1,
        clientReferenceData3: data.detail?.clientReferenceData3 ?? this.paymentPayload?.clientReferenceData3,
        clientReferenceData4: data.detail?.clientReferenceData4 ?? this.paymentPayload?.clientReferenceData4,
      });
      this.billingNewService.postPaymentEvent(paymentCompletePayload).subscribe();

      setTimeout(() => {
        this.policyDetailsService
          .getPolicyDetailsByEmail(this.userData.userDetails.email.address)
          .subscribe(() => console.log('fetched billing details'));
      }, 10000);
    });
    container.addEventListener('portalOne.error', (err: any) => {
      const paymentErrorPayload = JSON.stringify({
        paymentStatus:        'Failed',
        errorCode:            err.detail?.errorCode,
        errorMessage:         err.detail?.Description ?? err.detail?.errorMessage,
        clientReferenceData1: this.paymentPayload?.clientReferenceData1,
        clientReferenceData3: this.paymentPayload?.clientReferenceData3,
        clientReferenceData4: this.paymentPayload?.clientReferenceData4,
      });
      this.billingNewService.postPaymentEvent(paymentErrorPayload).subscribe();
    });
    container.addEventListener('portalOne.unload', () => {
      this.billingNewService.setOneIncPaymentStatus(false);
      console.log(' portalOne.unload');
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const prevPolicyNumber =
      changes['policy'].previousValue?.policynumber?.policyNumber;
    const currPolicyNumber =
      changes['policy'].currentValue?.policynumber?.policyNumber;
    if (prevPolicyNumber !== currPolicyNumber) {
      this.billingNewService.setOneIncPaymentStatus(false);
    }
  }

  ngOnDestroy() {
    if (this.container) {
      const newConatiner = this.container.cloneNode(true) as HTMLElement;
      this.container.replaceWith(newConatiner);
      this.container = null;
    }
    this.billingNewService.setOneIncPaymentStatus(false);
  }
}
